// Breakpoints defined in variables.scss.
const breakpoints = {
  s: 421,
  m: 701,
  l: 1181,
  xl: 1481,
};

const isMobile = (width = window.innerWidth) => {
  return width < breakpoints.l;
};

export default isMobile;
